import { HttpHeaders } from "@angular/common/http";

export const InterceptorSkipHeader = 'X-Skip-Interceptor';
export const SilentSpinnerHeader = 'X-Show-silent-Spinner';
export const silentSpinner = 'silentSpinner';
export const silentSpinnerHeaders: HttpHeaders = new HttpHeaders({ 'ClientSource': 'web', 'X-Show-silent-Spinner': 'true' });


export function isNullOrUndefined(data: unknown): boolean {
    return data === undefined || data === null;
}
